import {Component, Input, OnInit} from '@angular/core';
import {BehaviorSubject} from 'rxjs/index';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {TranslateService} from '../../../../../shared/translate.service';
import {AppConfigService} from '../../../../../config/app-config.service';
import {FiltersConfig} from '../../../../../config/filters/filters-config.model';
import {FilterBaseComponent} from '../../../../../search/search-list/filters/filter-block/filter-base/filter-base.component';
import {FiltersService} from '../../../../../search/search-list/filters/filters.service';
import {Filter} from '../../../../../search/search-list/filters/filter-block/filter-item/filter';
import {FilterTreeShowMoreModalComponent} from '../../../../../search/search-list/filters/filter-block/filter-tree/filter-tree-show-more-modal/filter-tree-show-more-modal.component';

@Component({
  selector: 'app-facet-tree',
  templateUrl: './facet-tree.component.html',
  styleUrls: ['./facet-tree.component.css']
})
export class FacetTreeComponent extends FilterBaseComponent implements OnInit {

  filters = new BehaviorSubject<Filter[]>([]);
  limitedFilters:any
  @Input() blockId: string = 'NoId';
  public active = false;

  constructor(public translator: TranslateService,
              protected modalService: NgbModal,
              public filtersService: FiltersService,
              public appConfigService: AppConfigService) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
    this.doRefresh();
  }

  doRefresh() {
    if (this.getBaseBlock()) {
      let filters = this.getBaseBlock().filters;
      this.limitedFilters = filters.length > 1000 ? filters.slice(0, 1000) : filters;
      this.filters.next(filters);
    }
  }

  isSimpleFilterAllowed(): boolean {
    if (this.filters.value.find(filter => filter.selected)) {
      return this.getBaseBlock() && this.getBaseBlock().filters.length > 0 && (this.getBaseBlock().filters.length > this.getBaseBlock().filterConfig.limitNestedIteration || this.filtersService.moreAvailable.includes(this.getBaseBlock().filterConfig.name));
    }else {
      return this.getBaseBlock() && this.getBaseBlock().filters.length > 0 && (this.countNonZeroes() > this.getBaseBlock().filterConfig.limitNestedIteration);
    }
  }

  filterEvent(filterPhrase: string) {
    let filtersFiltered = this.getBaseBlock().filters.filter(filter => this.translator.translate(filter.value).toLowerCase().includes(filterPhrase.toLowerCase()));
    this.limitedFilters = filtersFiltered.length > 1000 ? filtersFiltered.slice(0, 1000) : filtersFiltered;
    this.filters.next(filtersFiltered);
  }

  showMore(filterBlock) {
    const modalInstance = this.modalService.open(FilterTreeShowMoreModalComponent);
    modalInstance.componentInstance.filterBlock = filterBlock;
  }

  isShowMore (filters): boolean {
    return filters ? filters.find(filter => filter.selected === true) : false;
  }

  canEnableOr() {
    return this.filters.value.filter(filter => filter.selected).length > 0;
  }

  countNonZeroes() {
    return this.getBaseBlock().filters.filter(filter => filter.count>0).length;
  }

  protected getBaseBlock() {
    return this.filterBlock;
  }
}
